import { ScalePillDescription } from "../ScalesPillDescription"
import { BarometerChartComponent } from "../WithNeedleChart"
import "./styles.scss"
import { Radar, Bar } from "react-chartjs-2"
import {
  Chart as ChartJS,
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
} from "chart.js"

ChartJS.register(
  RadialLinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
)

export const EsmSpeedometerProducer = ({
  filter,
  setFilter,
  scaleTitle,
  scaleValue,
  esmUser,
  hiddenCards,
  categories,
  esmId,
}) => {
  const getColor = (value) => {
    if (value >= 80) {
      return "#0b7348"
    } else if (value >= 60) {
      return "#41a67c"
    } else if (value >= 40) {
      return "#ffcc01"
    } else if (value >= 20) {
      return "#ff8c02"
    } else {
      return "#ff0002"
    }
  }

  const getDescription = (value) => {
    if (value >= 80) return "Excelente desempenho"
    if (value >= 60) return "Bom desempenho"
    if (value >= 40) return "Desempenho médio"
    if (value >= 20) return "Precisa melhorar"
    return "Requer atenção imediata"
  }

  function wrapTextByWords(text, maxLength) {
    const words = text.split(" ")
    const lines = []
    let currentLine = ""

    for (const word of words) {
      if ((currentLine + word).length <= maxLength) {
        currentLine += (currentLine ? " " : "") + word
      } else {
        lines.push(currentLine)
        currentLine = word
      }
    }

    if (currentLine) {
      lines.push(currentLine)
    }

    return lines
  }

  const truncateText = (text, length) => {
    if (text.length > length) {
      return text.substring(0, length) + "..."
    }
    return text
  }

  // Função para dividir em duas linhas
  const splitLabel = (label, maxLength = 8) => {
    const words = label.split(" ")
    const lines = []
    let currentLine = ""

    for (const word of words) {
      if ((currentLine + " " + word).trim().length > maxLength) {
        lines.push(currentLine.trim())
        currentLine = word
      } else {
        currentLine += " " + word
      }
    }

    if (currentLine) lines.push(currentLine.trim())

    return lines
  }

  const barColors = [
    "#4CAF50", // verde
    "#2196F3", // azul
    "#FFC107", // amarelo
    "#9C27B0", // roxo
    "#FF5722", // laranja
    "#607D8B", // azul acinzentado
    "#E91E63", // rosa
    "#795548", // marrom
    "#00BCD4", // ciano
    "#FF9800", // laranja claro
  ]

  const chartData = {
    labels: categories?.map((c) => c.category.split(" - ").pop()) ?? [],
    datasets: [
      {
        label: " ", // Espaço em branco para forçar a exibição da legenda
        data: categories?.map((c) => c.mean) ?? [],
        backgroundColor: categories?.map((_, index) => barColors[index % barColors.length]) ?? [],
        borderColor: categories?.map((_, index) => barColors[index % barColors.length]) ?? [],
        borderWidth: 1,
      },
    ],
  }

  const radarOptions = {
    scales: {
      r: {
        beginAtZero: true,
        max: 100,
        stepSize: 20,
        suggestedMax: 100,
        suggestedMin: 0,
        pointLabels: {
          callback: function (label) {
            return splitLabel(label) // quebra em múltiplas linhas
          },
          font: {
            size: 12,
          },
        },
        ticks: {
          display: true,
          backdropColor: "transparent", // opcional: melhora o visual dos valores no eixo
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          title: function (context) {
            const index = context[0].dataIndex
            const fullLabel = categories?.[index]?.category || ""
            return wrapTextByWords(fullLabel, 30)
          },
          label: function (context) {
            const value = context.raw
            return `Média: ${parseFloat(value).toFixed(1)}`
          },
        },
      },
    },
    maintainAspectRatio: false,
  }

  const classesVale = `${esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc" ? "--vale" : ""}`
  return (
    <div className="esm-producer-info" style={{ marginBottom: "20px" }}>
      {esmUser && (
        <div className="esm-producer-info-header">
          <h1 className="esm-producer-info-header-name" title={esmUser?.name}>
            {esmUser?.name}
          </h1>
          <span className="esm-producer-info-header-email" title={esmUser?.email}>
            {esmUser?.email}
          </span>
        </div>
      )}
      <div className="esm-producer-info-chart">
        <div className="chart-box">
          <span className="indice-scale">{scaleTitle}</span>
          <BarometerChartComponent
            value={(scaleValue || 0) * 100}
            width={300}
            height={350}
            needleHeightRatio={0.3}
          />
        </div>
        <div className="scale-indicators">
          {/* {
            !hiddenCards && (
              <div className={`chart-indicators${` chart-indicators${classesVale}`}`}>
                {
                  Array.isArray(categories) && categories.map(({category, mean}) => (
                    <div
                      className={`chart-indicators-value${` chart-indicators-value${classesVale}`}`}
                      onClick={() => setFilter(filter !== category && category)} key={Math.random()}
                    >
                      <span className="chart-indicators-value-label">
                        {category.length > 20 ? `${category.slice(0, 18)}...` : category}
                      </span>
                      <div className={` chart-indicators-value-badge chart-indicators-value-badge ${getColor(mean)}`}>
                        {category ? parseFloat(mean).toFixed(1) : 0}
                      </div>
                    </div>
                  ))
                }
              </div>
            )
          } */}
          <div className="scale-pill-container">
            <ScalePillDescription
              label={
                esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
                  ? "MUITO ALTO"
                  : "ALTO (SUSTENTÁVEL)"
              }
              color="darkGreen"
            />
            <ScalePillDescription
              label={
                esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
                  ? "ALTO"
                  : "BOM (QUASE SUSTENTÁVEL)"
              }
              color="lightGreen"
            />
            <ScalePillDescription
              label={
                esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc" ? "MÉDIO" : "MÉDIO (INTERMEDIÁRIO)"
              }
              color="yellow"
            />
            <ScalePillDescription
              label={
                esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
                  ? "BAIXO"
                  : "BAIXO (QUASE INSUSTENTÁVEL)"
              }
              color="orange"
            />
            <ScalePillDescription
              label={
                esmId === "7ea1de77-706a-413f-a9da-cb6f82febcbc"
                  ? "MUITO BAIXO"
                  : "RUIM (INSUSTENTÁVEL)"
              }
              color="red"
            />
          </div>
        </div>
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "20px", padding: "20px", justifyContent: "center" }}>
        {categories?.map((category, index) => {
          const value = category.mean
          const color = getColor(value)
          const shortName = category.category.split(" - ").pop()

          return (
            <div
              key={index}
              style={{
                background: "white",
                borderRadius: "8px",
                padding: "20px",
                boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                flex: "1",
                minWidth: "300px",
                maxWidth: "400px",
              }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: "15px",
                }}>
                <div
                  style={{
                    width: "45px",
                    height: "45px",
                    position: "relative",
                  }}>
                  <svg
                    viewBox="0 0 36 36"
                    style={{
                      width: "100%",
                      height: "100%",
                      transform: "rotate(-90deg)",
                    }}>
                    <path
                      d="M18 2.0845
                          a 15.9155 15.9155 0 0 1 0 31.831
                          a 15.9155 15.9155 0 0 1 0 -31.831"
                      fill="none"
                      stroke="#eee"
                      strokeWidth="3"
                    />
                    <path
                      d="M18 2.0845
                          a 15.9155 15.9155 0 0 1 0 31.831
                          a 15.9155 15.9155 0 0 1 0 -31.831"
                      fill="none"
                      stroke={color}
                      strokeWidth="3"
                      strokeDasharray={`${value}, 100`}
                    />
                  </svg>
                  <div
                    style={{
                      position: "absolute",
                      top: "50%",
                      left: "50%",
                      transform: "translate(-50%, -50%)",
                      fontSize: "12px",
                      fontWeight: "bold",
                      color: color,
                    }}>
                    {value.toFixed(2)}
                  </div>
                </div>
                <div style={{ flex: 1 }}>
                  <h3 style={{ margin: 0, fontSize: "16px", color: "#333", marginBottom: "4px" }}>
                    {shortName}
                  </h3>
                  <p style={{ margin: 0, fontSize: "13px", color: "#666", lineHeight: "1.4" }}>
                    {getDescription(value)}
                  </p>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
